import React from "react";
import ReactDOM from "react-dom";
import { QueryClient, QueryClientProvider } from "react-query";

// recoil로 감싸야 사용 가능
import { RecoilRoot } from "recoil";
import App from "./App";

import "./css/contents_v1.css";
import "./css/contents.css";
import "./css/fullPage.css";
import "./css/jquery.modal.min.css";
import "./css/reset.css";
import "./fonts/font.css";

const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById("root")
);
